import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32ea3f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wizard-chat" }
const _hoisted_2 = {
  class: "wizard-messages",
  ref: "messagesContainer"
}
const _hoisted_3 = { class: "wizard-welcome-icon wizard-welcome-animate" }
const _hoisted_4 = { class: "wizard-welcome-title wizard-welcome-animate" }
const _hoisted_5 = { class: "wizard-welcome-subtitle wizard-welcome-animate" }
const _hoisted_6 = { class: "wizard-suggestions" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "wizard-mode-divider-label" }
const _hoisted_10 = { class: "wizard-message-bubble" }
const _hoisted_11 = {
  key: 0,
  class: "wizard-message-attachments"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "wizard-attachment-card-meta" }
const _hoisted_14 = { class: "wizard-attachment-card-name" }
const _hoisted_15 = { class: "wizard-attachment-card-size" }
const _hoisted_16 = ["title", "onClick"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "wizard-loading-indicator"
}
const _hoisted_19 = { class: "wizard-loading-word" }
const _hoisted_20 = {
  key: 2,
  class: "wizard-interruption-indicator"
}
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = { class: "wizard-connection-prompt-question" }
const _hoisted_23 = { class: "wizard-connection-prompt-actions" }
const _hoisted_24 = { class: "wizard-input-area" }
const _hoisted_25 = {
  key: 0,
  class: "wizard-attachment-tray"
}
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "wizard-attachment-chip-name" }
const _hoisted_28 = { class: "wizard-attachment-chip-size" }
const _hoisted_29 = ["title", "onClick"]
const _hoisted_30 = ["title", "onClick"]
const _hoisted_31 = {
  key: 1,
  class: "wizard-attachment-notice"
}
const _hoisted_32 = {
  key: 2,
  class: "wizard-mention-popup"
}
const _hoisted_33 = ["onMousedown", "onMousemove"]
const _hoisted_34 = { class: "wizard-mention-name" }
const _hoisted_35 = { class: "wizard-mention-size" }
const _hoisted_36 = { class: "wizard-mention-time" }
const _hoisted_37 = { class: "wizard-input-wrapper" }
const _hoisted_38 = ["accept"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "node-summary-literal wizard-tooltip-key" }, "@", -1))
const _hoisted_40 = ["disabled", "aria-label"]
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = ["disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_WizardContextRing = _resolveComponent("WizardContextRing")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.messages.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", {
            key: _ctx.mode,
            class: "wizard-welcome"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.mode === 'chat' ? 'comment' : 'magic'
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.welcomeTitle), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.welcomeSubtitle), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: suggestion,
                  class: "wizard-suggestion-chip",
                  style: _normalizeStyle({ animationDelay: `${0.28 + index * 0.08}s` }),
                  onClick: ($event: any) => (_ctx.sendSuggestion(suggestion))
                }, _toDisplayString(suggestion), 13, _hoisted_7))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (msg.role === 'mode_divider')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "wizard-mode-divider",
                "aria-label": `Switched to ${
            msg.toMode === 'chat' ? 'Chat' : 'Creator'
          } mode`
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(msg.toMode === "chat"
                ? "Switched to Chat mode"
                : "Switched to Creator mode"), 1)
              ], 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["wizard-message", 
            msg.role === 'user'
              ? 'wizard-message--user'
              : 'wizard-message--assistant'
          ])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (msg.attachments && msg.attachments.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.attachments, (att) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: att.id,
                            class: "wizard-attachment-card",
                            title: _ctx.displayNameById[att.id] || att.name
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "wizard-attachment-card-icon",
                              icon: _ctx.iconForType(att.contentType)
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.displayNameById[att.id] || att.name), 1),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatSize(att.size)), 1)
                            ]),
                            _createElementVNode("button", {
                              class: "wizard-attachment-card-download",
                              title: _ctx.t('TeggyAssistant.Download'),
                              onClick: _withModifiers(($event: any) => (_ctx.downloadSent(att)), ["stop"])
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "download" })
                            ], 8, _hoisted_16)
                          ], 8, _hoisted_12))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (msg.content)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["wizard-message-content", 
                msg.role === 'user'
                  ? 'wizard-message-content--user'
                  : 'wizard-message-content--assistant'
              ]),
                        innerHTML: _ctx.formatMessage(msg)
                      }, null, 10, _hoisted_17))
                    : _createCommentVNode("", true)
                ])
              ], 2))
        ], 64))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.loadingWord), 1)
          ]))
        : (_ctx.interruptionNotice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.interruptionNotice), 1))
          : _createCommentVNode("", true),
      (_ctx.connectionPrompt)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            id: "wizard-connection-prompt",
            class: "wizard-connection-prompt",
            role: "group",
            "aria-live": "polite",
            "aria-label": _ctx.connectionPrompt.question
          }, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.connectionPrompt.question), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                id: "wizard-connection-prompt-open",
                type: "button",
                class: "wizard-connection-prompt-btn wizard-connection-prompt-btn--open",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-connection-setup')))
              }, _toDisplayString(_ctx.t("TeggyAssistant.ConnectionSetupOpen")), 1),
              _createElementVNode("button", {
                id: "wizard-connection-prompt-dismiss",
                type: "button",
                class: "wizard-connection-prompt-btn wizard-connection-prompt-btn--dismiss",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dismiss-connection-setup')))
              }, _toDisplayString(_ctx.t("TeggyAssistant.ConnectionSetupNotNow")), 1)
            ])
          ], 8, _hoisted_21))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_24, [
      (_ctx.pendingAttachments.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingAttachments, (att) => {
              return (_openBlock(), _createElementBlock("div", {
                key: att.localId,
                class: _normalizeClass(["wizard-attachment-chip", {
            'wizard-attachment-chip--uploading': att.status === 'uploading',
            'wizard-attachment-chip--error': att.status === 'error',
          }]),
                title: att.error || (att.id && _ctx.displayNameById[att.id]) || att.name
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "wizard-attachment-chip-icon",
                  icon: 
              att.status === 'uploading'
                ? 'spinner'
                : _ctx.iconForType(att.contentType)
            ,
                  spin: att.status === 'uploading'
                }, null, 8, ["icon", "spin"]),
                _createElementVNode("span", _hoisted_27, _toDisplayString((att.id && _ctx.displayNameById[att.id]) || att.name), 1),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formatSize(att.size)), 1),
                (att.rawText !== undefined && att.status === 'ready')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "wizard-attachment-chip-action",
                      title: _ctx.t('TeggyAssistant.ShowInTextField'),
                      onClick: _withModifiers(($event: any) => (_ctx.revertPasted(att)), ["stop"])
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                    ], 8, _hoisted_29))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "wizard-attachment-chip-remove",
                  title: _ctx.t('TeggyAssistant.Remove'),
                  onClick: _withModifiers(($event: any) => (_ctx.removeAttachment(att.localId)), ["stop"])
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "times" })
                ], 8, _hoisted_30)
              ], 10, _hoisted_26))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.attachmentNotice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.attachmentNotice), 1))
        : _createCommentVNode("", true),
      (_ctx.mentionOpen && _ctx.mentionResults.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mentionResults, (file, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: file.id,
                class: _normalizeClass(["wizard-mention-item", {
            'wizard-mention-item--active': index === _ctx.mentionActiveIndex,
          }]),
                onMousedown: _withModifiers(($event: any) => (_ctx.selectMention(file)), ["prevent"]),
                onMousemove: ($event: any) => (_ctx.mentionActiveIndex = index)
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "wizard-mention-icon",
                  icon: _ctx.iconForType(file.contentType)
                }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_34, _toDisplayString(file.displayName), 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.formatSize(file.size)), 1),
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatAttachedAt(file.attachedAt)), 1)
              ], 42, _hoisted_33))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("input", {
          ref: "fileInputRef",
          type: "file",
          multiple: "",
          class: "wizard-file-input",
          accept: _ctx.acceptAttr,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFilesPicked && _ctx.onFilesPicked(...args)))
        }, null, 40, _hoisted_38),
        _createVNode(_component_ElTooltip, {
          effect: "custom",
          placement: "top",
          "show-after": 250
        }, {
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("TeggyAssistant.AddFilesAndMore")) + " ", 1),
            _hoisted_39
          ]),
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "wizard-attach-btn",
              disabled: _ctx.loading,
              "aria-label": _ctx.t('TeggyAssistant.AddFilesAndMore'),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openFilePicker && _ctx.openFilePicker(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "paperclip" })
            ], 8, _hoisted_40)
          ]),
          _: 1
        }),
        _createVNode(_component_WizardContextRing, {
          level: _ctx.contextLevel,
          open: _ctx.contextMenuOpen,
          compacting: _ctx.compacting,
          error: _ctx.contextError,
          onToggle: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle-context'))),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close-context'))),
          onCompact: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('compact-context')))
        }, null, 8, ["level", "open", "compacting", "error"]),
        _withDirectives(_createElementVNode("textarea", {
          ref: "inputRef",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputText) = $event)),
          class: "wizard-input",
          placeholder: _ctx.inputPlaceholder,
          rows: "1",
          onKeydown: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
          onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
          onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateMention && _ctx.updateMention(...args))),
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateMention && _ctx.updateMention(...args))),
          onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeMention && _ctx.closeMention(...args))),
          onPaste: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args)))
        }, null, 40, _hoisted_41), [
          [_vModelText, _ctx.inputText]
        ]),
        _createVNode(_component_ElTooltip, {
          effect: "custom",
          placement: "top",
          "show-after": 250,
          content: _ctx.sendButtonLabel
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: _normalizeClass(["wizard-send-btn", { 'wizard-send-btn--stop': _ctx.loading }]),
              disabled: _ctx.loading ? !_ctx.canStop : !_ctx.canSend,
              "aria-label": _ctx.sendButtonLabel,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loading ? _ctx.stop() : _ctx.send()))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.loading ? 'stop' : 'arrow-up'
              }, null, 8, ["icon"])
            ], 10, _hoisted_42)
          ]),
          _: 1
        }, 8, ["content"])
      ])
    ])
  ]))
}